import { render, staticRenderFns } from "./StepperNavigationRoundedButton.vue?vue&type=template&id=456538b3&"
import script from "./StepperNavigationRoundedButton.vue?vue&type=script&lang=js&"
export * from "./StepperNavigationRoundedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports